import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Formik, Form } from 'formik';
import { Checkbox, Container, FormControlLabel, IconButton, TextField, TextareaAutosize } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { sorunTipi, aksiyonSahibi } from '../../helpers/ProcessData';
import Textarea from '@mui/joy/Textarea';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState, useEffect } from 'react';
import { uygunsuzlukTipi } from "../../helpers/ProcessData"
import { useSelector } from "react-redux"
import useArge from '../../hooks/useArge';
import Autocomplete from '@mui/material/Autocomplete';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,

};

const HammaddeHazirlamaModal = ({ open, handleClose, info, setInfo, workCenterCode, materialCode, machineLoading, materialLoading }) => {

  const nowData = new Date()
  const currentdatetime = nowData.getDate() + "-" + (nowData.getMonth() + 1) + "-" + nowData.getFullYear()
  const currentTime = nowData.getHours() + ":" + nowData.getMinutes()
  const [isCheck, setIsCheck] = useState(false)
  const [newMaterialName, setnewMaterialName] = useState(false)

  const [search, setSearch] = useState(null)
  const [searchSorunTipi, setSearchSorunTipi] = useState(null)

  const handleChange = (e, newValue, fieldName) => {

    // Autocomplete'ten gelen olaylar için
    if (fieldName) {
      setInfo(prevInfo => ({
        ...prevInfo,
        [fieldName]: newValue?.MALZEMEKODU || newValue?.text || ""
      }));
    }
    // TextField'tan gelen olaylar için
    else if (e?.target) {
      const { name, value } = e.target;
      // setInfo(prevInfo => ({
      //   ...prevInfo,
      //   [name]: value
      // }));

      setInfo(prevInfo => {

        const newInfo = { ...prevInfo, [name]: value }

        if (isCheck && newInfo.oldData_date) {

          const dateStr = newInfo.oldData_date.split('T')
          const parts = dateStr[0].split('-')
          newInfo.date = `${parts[2]}-${parts[1]}-${parts[0]}`
          newInfo.time = dateStr[1]
        }
        else {

          newInfo.date = currentdatetime.toString()
          newInfo.time = currentTime.toString()
        }

        //?yeni ürün kodu bilgisi manuel olarak yazılırsa ürün_kodu değerini yazdır
        if (newMaterialName) {
          newInfo.urun_kodu = newInfo.newMaterialName.toUpperCase()
        }


        return newInfo
      })

    }
  }

  const { getFireData, putFireData, postFireData } = useArge()


  const handleSubmit = (e) => {

    e.preventDefault()

    if (info?.id) {
      putFireData('HammaddeHazirlama', info)
      getFireData("HammaddeHazirlama")

    }
    else {
      postFireData("HammaddeHazirlama", info)
      getFireData("HammaddeHazirlama")

    }

    handleClose()

  }


  // checkbox fonksiyon
  const handleIsCheck = (e) => {
    const { checked, name } = e.target
    if (name === "oldData") {

      setIsCheck(checked)
    }
    else if (name === 'newMaterialName') {
      setnewMaterialName(checked)
    }
  }

  // checkbox false yap ve date bilgisini temizle
  function handleIsCheck_Reset() {
    setIsCheck(false)
    setInfo({ ...info, ['oldData_date']: "", ['newMaterialName']: "" })
  }


  return (
    <div>

      <Modal
        keepMounted
        open={open}
        onClose={() => {
          handleClose()
          handleIsCheck_Reset()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography id="keep-mounted-modal-title" variant="h6" component="h2" color="#000000">
              Hammadde Hazirlama
            </Typography>

            <IconButton onClick={() => {
              handleClose()
              handleIsCheck_Reset()
            }}>
              <HighlightOffIcon sx={{ color: '#C70039', fontSize: '28px' }} />
            </IconButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', p: 2, border: '1px solid gray', borderRadius: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
              <FormControlLabel
                control={
                  <Checkbox checked={isCheck} onChange={handleIsCheck} name="oldData" />
                }
                label="Geçmiş tarihli veri girişi"
              />
              {
                isCheck && <TextField
                  size='small'
                  name='oldData_date'
                  id='oldData_date'
                  type='datetime-local'
                  onChange={handleChange}
                />
              }

            </Box>
            {
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
                <FormControlLabel
                  control={
                    <Checkbox checked={newMaterialName} onChange={handleIsCheck} name="newMaterialName" />
                  }
                  label="Yeni malzeme adı"
                />
                {
                  newMaterialName && <TextField
                    size='small'
                    name='newMaterialName'
                    id='newMaterialName'
                    value={info.newMaterialName}
                    type='text'
                    onChange={handleChange}
                  />
                }

              </Box>
            }

          </Box>


          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'scroll', maxHeight: '550px' }} component='form' onSubmit={handleSubmit}>


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              {/* makine */}
              <FormControl fullWidth>
                <InputLabel id="is_merkezi">Makine</InputLabel>
                <Select
                  disabled={machineLoading}
                  required
                  labelId="is_merkezi"
                  id="is_merkezi"
                  name='is_merkezi'
                  label="is_merkezi"
                  value={info?.is_merkezi}
                  onChange={handleChange}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflow: 'auto'
                      }
                    }
                  }}
                >
                  {
                    workCenterCode?.filter(data => data?.ISMERKEZI?.includes('SK-KP')).map(({ ISMERKEZI, index }) => (
                      <MenuItem key={index} value={ISMERKEZI}>{ISMERKEZI}</MenuItem>
                    ))
                  }

                </Select>

              </FormControl>


              {/* yeni ürün kodu manuel olarak eklemek istenirse seçmeli ürün kodlarını görünümünü kapat */}
              {
                newMaterialName ?
                  (
                    ""
                  )
                  :
                  (
                    <Autocomplete
                      fullWidth
                      value={info.urun_kodu ? { MALZEMEKODU: info.urun_kodu } : search}
                      name='urun_kodu'
                      onChange={(event, newValue) => {
                        setSearch(newValue);
                        handleChange(event, newValue, 'urun_kodu')
                      }}
                      id="search-select-demo"
                      options={materialCode}
                      getOptionLabel={(option) => option.MALZEMEKODU}
                      renderInput={(params) => <TextField {...params} label="Ürün Kodu" />}
                    />
                  )
              }

            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="Granül Nem Oranı (%)"
                name="granulNemOrani"
                id="granulNemOrani"
                type="text"
                variant="outlined"

                value={info?.granulNemOrani}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="500 Mikron"
                name="besyuzMikron"
                id="besyuzMikron"
                type="text"
                variant="outlined"

                value={info?.besyuzMikron}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="400 Mikron"
                name="dortyuzMikron"
                id="dortyuzMikron"
                type="text"
                variant="outlined"

                value={info?.dortyuzMikron}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="315 Mikron"
                name="ucyuzonbesMikron"
                id="ucyuzonbesMikron"
                type="text"
                variant="outlined"

                value={info?.ucyuzonbesMikron}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="250 Mikron"
                name="ikiyuzelliMikron"
                id="ikiyuzelliMikron"
                type="text"
                variant="outlined"

                value={info?.ikiyuzelliMikron}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="200 Mikron"
                name="ikiyuzMikron"
                id="ikiyuzMikron"
                type="text"
                variant="outlined"

                value={info?.ikiyuzMikron}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="100 Mikron"
                name="yuzMikron"
                id="yuzMikron"
                type="text"
                variant="outlined"

                value={info?.yuzMikron}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="<100 Mikron"
                name="lessthanyuzMikron"
                id="lessthanyuzMikron"
                type="text"
                variant="outlined"

                value={info?.lessthanyuzMikron}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Granül Akışı (sn)"
                name="granulAkisi"
                id="granulAkisi"
                type="text"
                variant="outlined"

                value={info?.granulAkisi}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Granül Yoğunluğu (%)"
                name="granulYogunluk"
                id="granulYogunluk"
                type="text"
                variant="outlined"

                value={info?.granulYogunluk}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="Hızlı Mikser - Sıcaklık"
                name="mikserSicaklik"
                id="mikserSicaklik"
                type="text"
                variant="outlined"

                value={info?.mikserSicaklik}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Hızlı Mikser - Yoğunluk"
                name="mikserYogunluk"
                id="mikserYogunluk"
                type="text"
                variant="outlined"

                value={info?.mikserYogunluk}
                onChange={handleChange}
              />
            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="Viskozite t1"
                name="viskozite_t1"
                id="viskozite_t1"
                type="text"
                variant="outlined"

                value={info?.viskozite_t1}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Viskozite t2"
                name="viskozite_t2"
                id="viskozite_t2"
                type="text"
                variant="outlined"

                value={info?.viskozite_t2}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Tiksotropi t1-t2"
                name="tiksotropi_t1t2"
                id="tiksotropi_t1t2"
                type="text"
                variant="outlined"

                value={info?.tiksotropi_t1t2}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="Tank Sicaklik"
                name="sirlamaTankiSicaklik"
                id="sirlamaTankiSicaklik"
                type="text"
                variant="outlined"

                value={info?.sirlamaTankiSicaklik}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Tank Yogunluk"
                name="sirlamaTankiYogunluk"
                id="sirlamaTankiYogunluk"
                type="text"
                variant="outlined"

                value={info?.sirlamaTankiYogunluk}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="ph"
                name="ph"
                id="ph"
                type="text"
                variant="outlined"

                value={info?.ph}
                onChange={handleChange}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                fullWidth
                label="Viskozite g1"
                name="viskozite_g1"
                id="viskozite_g1"
                type="text"
                variant="outlined"

                value={info?.viskozite_g1}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Viskozite g2"
                name="viskozite_g2"
                id="viskozite_g2"
                type="text"
                variant="outlined"

                value={info?.viskozite_g2}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Tiksotropi g1g2"
                name="tiksotropi_g1g2"
                id="tiksotropi_g1g2"
                type="text"
                variant="outlined"

                value={info?.tiksotropi_g1g2}
                onChange={handleChange}
              />
            </Box>



            {/* aksiyon sahibi */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>

              <Autocomplete
                fullWidth
                value={searchSorunTipi}
                name='uygunsuzluktipi'
                onChange={(event, newValue) => {
                  setSearchSorunTipi(newValue);
                  handleChange(event, newValue, 'uygunsuzluktipi')
                }}
                id="search-select-demo"
                options={uygunsuzlukTipi}
                getOptionLabel={(option) => option.text}
                renderInput={(params) => <TextField {...params} label="Sorun Tipi" />}
              />

              {/* RESET BUTTON */}
              {/* select içinde selçilen değeri resetlemek için kullanılan buton */}
              {/* <Button variant='contained' size='small' sx={{ textTransform: 'none' }} onClick={() => setInfo(prevInfo => ({ ...prevInfo, uygunsuzluktipi: '' }))}>Reset</Button> */}
            </Box>


            <TextField
              multiline
              fullWidth
              label="Açıklama"
              name="aciklama"
              id="aciklama"
              type="text"
              variant="outlined"
              InputProps={{ inputProps: { min: 0 } }}
              value={info?.aciklama}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Vardiya Sorumlusu veya Operatör"
              name="vardiyasorumlusu"
              id="vardiyasorumlusu"
              type="text"
              variant="outlined"

              value={info?.vardiyasorumlusu}
              onChange={handleChange}
            />



            <Button
              variant='contained'
              fullWidth
              type='submit'
            >
              {info?.id ? "Update Data" : "Add New Data"}
            </Button>


          </Box>


        </Box>
      </Modal>
    </div>
  );
}

export default HammaddeHazirlamaModal